import FileSaver from 'file-saver';

export interface CreateAndDownloadFilePayload {
  data: Blob;
  filename: string;
  fileType: string;
}

export const createAndDownloadFile = (
  payload: CreateAndDownloadFilePayload,
) => {
  const blob = new Blob([payload.data], {
    type: payload.fileType,
  });
  FileSaver.saveAs(blob, payload.filename);
};
